import React from "react"
import { graphql } from "gatsby"

import extractNavigation from "../utils/extract-navigation"

import Page from "../components/page"
import Footer from "../components/footer"
import HorizontalTeaser from "../components/horizontal-teaser"
import TripleFacts from "../components/triple-facts"
import HorizontalCollage from "../components/horizontal-collage"
import Cards from "../components/cards"
import ArticlesTeaser from "../components/articles-teaser"
import FullwidthTeaser from "../components/fullwidth-teaser"
import TripleBenefits from "../components/triple-benefits"
import Partners from "../components/partners"

import "normalize.css"
import "../assets/scss/site.scss"

export const query = graphql`
  query IndexPage {
    pageData: datoCmsPage(slug: { eq: "start" }, locale: { eq: "en" }) {
      ...PageFields
    }
    footer: datoCmsFooter {
      ...FooterFields
    }
    translations: allLanguagesYaml {
      ...LanguagesData
    }
    navigationData: allNavigationYaml {
      ...NavigationData
    }
    navigationSecondaryData: allNavigationSecondaryYaml {
      ...NavigationSecondaryData
    }
    teaserGreenBatteriesEn: datoCmsTeaser(
      key: { eq: "teaser-green-batteries" }
      locale: { eq: "en" }
    ) {
      ...HorizontalTeaserFields
    }
    teaserMadeOfBatteriesEn: datoCmsTeaser(
      key: { eq: "teaser-batteries-made-from-batteries-index" }
      locale: { eq: "en" }
    ) {
      ...HorizontalTeaserFields
    }
    teaserWorkingAtNorthvolt: datoCmsGalleryTeaser(
      key: { eq: "teaser-working-at-northvolt" }
      locale: { eq: "en" }
    ) {
      ...HorizontalCollageFields
    }
    teaserPoweredByNatureEn: datoCmsFullwidthTeaser(
      key: { eq: "powered-by-nature" }
      locale: { eq: "en" }
    ) {
      ...FullWidthTeaserFields
    }
    cardExample: datoCmsCard(
      key: { eq: "card-solutions" }
      locale: { eq: "en" }
    ) {
      ...CardsFields
    }
    everyArticleEn: allDatoCmsArticle(
      filter: { locale: { eq: "en" } }
      sort: { fields: publishedDate, order: DESC }
      limit: 500
    ) {
      nodes {
        ...ArticleTeaserFields
      }
    }
    articlesTeaserEn: datoCmsArticlesTeaser(
      key: { eq: "front-article-teasers" }
      locale: { eq: "en" }
    ) {
      ...ArticlesTeaserFields
    }
    partnerWhyNorthvoltEn: datoCmsPartner(
      key: { eq: "why-northvolt-partners" }
      locale: { eq: "en" }
    ) {
      ...PartnerFields
    }
    tripleFactsEn: datoCmsTripleFactsComponent(
      key: { eq: "first-page-facts" }
      locale: { eq: "en" }
    ) {
      ...TripleFactsFields
    }
    tripleBenefitsEn: datoCmsTripleBenefitsComponent(
      key: { eq: "the-northvolt-way" }
      locale: { eq: "en" }
    ) {
      ...TripleBenefitsFields
    }
  }
`

import { IndexPageQuery } from "../../graphql-types"

interface IndexPageProps {
  data: IndexPageQuery
}

const IndexRoute: React.FC<IndexPageProps> = ({ data }) => {
  const topnavItems = extractNavigation(data.navigationData)
  const secondaryNavItems = extractNavigation(data.navigationSecondaryData)

  return (
    <section className="c-body">
      <Page
        translations={data.translations}
        navigationData={topnavItems}
        navigationSecondaryData={secondaryNavItems}
        {...data.pageData}
      >
        <Partners
          variant="noheader -small"
          {...data.partnerWhyNorthvoltEn}
        ></Partners>
        <HorizontalTeaser
          {...data.teaserGreenBatteriesEn}
          variant={["largerimagemobile"]}
        ></HorizontalTeaser>
        <TripleFacts {...data.tripleFactsEn}></TripleFacts>
        <HorizontalCollage
          {...data.teaserWorkingAtNorthvolt}
          variant=""
        ></HorizontalCollage>
        <FullwidthTeaser
          {...data.teaserPoweredByNatureEn}
          variant="extra-margin"
        ></FullwidthTeaser>
        <Cards {...data.cardExample}></Cards>
        <ArticlesTeaser
          {...data.articlesTeaserEn}
          articles={data.everyArticleEn.nodes}
        ></ArticlesTeaser>
        <HorizontalTeaser
          variant={["right", "largeheader", "largeheadermobile", "linkbutton"]}
          {...data.teaserMadeOfBatteriesEn}
        ></HorizontalTeaser>
        <TripleBenefits
          {...data.tripleBenefitsEn}
          variant="o-wrapper-desktop -no-bottom-margin-mobile"
        ></TripleBenefits>
        <Footer {...data.footer} />
      </Page>
    </section>
  )
}

export default IndexRoute
